import React, { Component } from "react";
import Cookie from 'js-cookie';
import { redirectTo } from "./Redirect";


const AuthToken = Cookie.get('x-auth-token');

export function PrivateRoute(WrappedComponent) {
  return class extends Component {

    static async getInitialProps(ctx) {


      const auth = AuthToken;
      const initialProps = { auth };

      // redirect if you're not loggedIN
      if (typeof window !== "undefined") {
        if (!auth) redirectTo(ctx.res, "/login")
      }

      if (WrappedComponent.getInitialProps) {
        const wrappedProps = await WrappedComponent.getInitialProps(initialProps);
        return { ...wrappedProps };
      }
      return initialProps;
    }


    render() {
      return <WrappedComponent />;
    }
  };
}